import React from 'react';
import CheckboxRadioButton from './CheckboxRadioButton.jsx';
import CheckboxLike from '@ignitesales/neuro-application/src/components/questions/types/CheckboxLike.jsx';

const CheckboxButton = (props) => {
  return <CheckboxLike { ...props } component={ CheckboxRadioButton }/>;
};

export default CheckboxButton;
